export const AGENT_SHEET_OPEN = 'AGENT_SHEET_OPEN';
export const AGENT_SHEET_CLOSE = 'AGENT_SHEET_CLOSE';
export const AGENT_SHEET_TOGGLE_COLLAPSE = 'AGENT_SHEET_TOGGLE_COLLAPSE';
export const AGENT_SHEET_SET_HEIGHT = 'AGENT_SHEET_SET_HEIGHT';

export const AGENT_THREAD_SELECT = 'AGENT_THREAD_SELECT';
export const AGENT_THREAD_LIST_REQUEST = 'AGENT_THREAD_LIST_REQUEST';
export const AGENT_THREAD_LIST_DONE = 'AGENT_THREAD_LIST_DONE';
export const AGENT_THREAD_LIST_ERROR = 'AGENT_THREAD_LIST_ERROR';

export const AGENT_THREAD_CREATE_REQUEST = 'AGENT_THREAD_CREATE_REQUEST';
export const AGENT_THREAD_CREATE_DONE = 'AGENT_THREAD_CREATE_DONE';
export const AGENT_THREAD_LOAD_REQUEST = 'AGENT_THREAD_LOAD_REQUEST';
export const AGENT_THREAD_LOAD_DONE = 'AGENT_THREAD_LOAD_DONE';
export const AGENT_THREAD_ERROR = 'AGENT_THREAD_ERROR';

export const AGENT_THREAD_DELETE_REQUEST = 'AGENT_THREAD_DELETE_REQUEST';
export const AGENT_THREAD_DELETE_DONE = 'AGENT_THREAD_DELETE_DONE';

export const AGENT_MESSAGE_SEND = 'AGENT_MESSAGE_SEND';
export const AGENT_MESSAGE_SEND_DONE = 'AGENT_MESSAGE_SEND_DONE';

export const AGENT_STREAM_EVENT = 'AGENT_STREAM_EVENT';
export const AGENT_STREAM_STATUS = 'AGENT_STREAM_STATUS';

export const AGENT_CONFIRM_TOOL = 'AGENT_CONFIRM_TOOL';
export const AGENT_STOP_TURN = 'AGENT_STOP_TURN';
export const AGENT_CONTINUE_TURN = 'AGENT_CONTINUE_TURN';

export function openAgentSheet() {
    return {type: AGENT_SHEET_OPEN};
}

export function closeAgentSheet() {
    return {type: AGENT_SHEET_CLOSE};
}

export function toggleAgentCollapse() {
    return {type: AGENT_SHEET_TOGGLE_COLLAPSE};
}

export function setAgentSheetHeight(height) {
    return {type: AGENT_SHEET_SET_HEIGHT, data: {height}};
}

export function selectAgentThread(threadId) {
    return {type: AGENT_THREAD_SELECT, data: {threadId}};
}

export function requestAgentThreadList(query) {
    return {type: AGENT_THREAD_LIST_REQUEST, data: query ?? {}};
}

export function doneAgentThreadList(data) {
    return {type: AGENT_THREAD_LIST_DONE, data};
}

export function errorAgentThreadList(error) {
    return {type: AGENT_THREAD_LIST_ERROR, data: {error}};
}

export function createAgentThread() {
    return {type: AGENT_THREAD_CREATE_REQUEST};
}

export function doneAgentThreadCreate(data) {
    return {type: AGENT_THREAD_CREATE_DONE, data};
}

export function loadAgentThread(threadId) {
    return {type: AGENT_THREAD_LOAD_REQUEST, data: {threadId}};
}

export function doneAgentThreadLoad(data) {
    return {type: AGENT_THREAD_LOAD_DONE, data};
}

export function errorAgentThread(payload) {
    return {type: AGENT_THREAD_ERROR, data: payload};
}

export function deleteAgentThread(threadId) {
    return {type: AGENT_THREAD_DELETE_REQUEST, data: {threadId}};
}

export function doneAgentThreadDelete(threadId) {
    return {type: AGENT_THREAD_DELETE_DONE, data: {threadId}};
}

/**
 * `attachments` rides on the action rather than being read from the store by the
 * middleware, because the reducer clears them on this very action — and the
 * middleware runs after reduction. Passing them explicitly avoids a third
 * pre-reduction read in agentMiddleware.
 *
 * `mode` is a ONE-OFF override for this single message (the "retry with deeper
 * reasoning" button) — omit it for an ordinary send, which lets the thread's
 * persisted `defaultMode` (set via setAgentThreadMode) govern instead.
 */
export function sendAgentMessage(threadId, text, attachments, mode) {
    return {type: AGENT_MESSAGE_SEND, data: {threadId, text, attachments: attachments ?? [], mode}};
}

export function doneAgentMessageSend(payload) {
    return {type: AGENT_MESSAGE_SEND_DONE, data: payload};
}

export function agentStreamEvent(payload) {
    return {type: AGENT_STREAM_EVENT, data: payload};
}

export function agentStreamStatus(payload) {
    return {type: AGENT_STREAM_STATUS, data: payload};
}

export function confirmAgentTool(payload) {
    return {type: AGENT_CONFIRM_TOOL, data: payload};
}

export function stopAgentTurn(payload) {
    return {type: AGENT_STOP_TURN, data: payload};
}

export function continueAgentTurn(payload) {
    return {type: AGENT_CONTINUE_TURN, data: payload};
}

export const AGENT_FILE_UPLOAD = 'AGENT_FILE_UPLOAD';
export const AGENT_FILE_UPLOAD_DONE = 'AGENT_FILE_UPLOAD_DONE';
export const AGENT_FILE_UPLOAD_ERROR = 'AGENT_FILE_UPLOAD_ERROR';
export const AGENT_FILE_REMOVE = 'AGENT_FILE_REMOVE';

export function uploadAgentFile(threadId, file) {
    return {type: AGENT_FILE_UPLOAD, data: {threadId, file}};
}

export function doneAgentFileUpload(payload) {
    return {type: AGENT_FILE_UPLOAD_DONE, data: payload};
}

export function errorAgentFileUpload(payload) {
    return {type: AGENT_FILE_UPLOAD_ERROR, data: payload};
}

export function removeAgentFile(threadId, fileId) {
    return {type: AGENT_FILE_REMOVE, data: {threadId, fileId}};
}

export const AGENT_THREAD_MODE_REQUEST = 'AGENT_THREAD_MODE_REQUEST';
export const AGENT_THREAD_MODE_DONE = 'AGENT_THREAD_MODE_DONE';

/** PATCHes the thread's persisted mode preference (§9 of the handoff). */
export function setAgentThreadMode(threadId, mode) {
    return {type: AGENT_THREAD_MODE_REQUEST, data: {threadId, mode}};
}

export function doneAgentThreadMode(payload) {
    return {type: AGENT_THREAD_MODE_DONE, data: payload};
}

export const AGENT_PRESETS_REQUEST = 'AGENT_PRESETS_REQUEST';
export const AGENT_PRESETS_DONE = 'AGENT_PRESETS_DONE';
export const AGENT_PRESETS_ERROR = 'AGENT_PRESETS_ERROR';
export const AGENT_PRESET_SELECT = 'AGENT_PRESET_SELECT';

/** GET /v1/presets — a developer/admin affordance, see agent-access.jsx. */
export function requestAgentPresets() {
    return {type: AGENT_PRESETS_REQUEST};
}

export function doneAgentPresets(presets) {
    return {type: AGENT_PRESETS_DONE, data: {presets}};
}

export function errorAgentPresets(error) {
    return {type: AGENT_PRESETS_ERROR, data: {error}};
}

/** Which preset the NEXT new thread is created on; existing threads keep theirs. */
export function selectAgentPreset(preset) {
    return {type: AGENT_PRESET_SELECT, data: {preset}};
}

export const AGENT_USAGE_REQUEST = 'AGENT_USAGE_REQUEST';
export const AGENT_USAGE_DONE = 'AGENT_USAGE_DONE';
export const AGENT_USAGE_ERROR = 'AGENT_USAGE_ERROR';

export function requestAgentUsage(query) {
    return {type: AGENT_USAGE_REQUEST, data: query ?? {}};
}

export function doneAgentUsage(report) {
    return {type: AGENT_USAGE_DONE, data: {report}};
}

export function errorAgentUsage(error) {
    return {type: AGENT_USAGE_ERROR, data: {error}};
}
